import Vue from 'vue'
import axios from 'axios'

const baseUrl = `/wp-json/wp/v2`
import accordion from '../components/accordionParent.vue'
import vqAccordion from '../components/vqAccordion'

if (document.getElementById('vue-solutions')) {
  new Vue({
    delimiters: ["[[", "]]"],
    el: '#vue-solutions',
    components: {
        vqAccordion,
        accordion
    },
    data() {
      return {
        isLoading: true,
        categories: [],
        filters: {
          page: 1,
          per_page: 100,
        },
        solutions: [],
        totalPages: null
      }
    },
    mounted() {
      this.getCategories()
      this.getSolutions()
    },
    methods: {
      getCategories() {
        axios.request({
          method: 'GET',
          url: `${baseUrl}/categories_solutions`,
          params: {
            per_page: 100,
          }
        }).then(response => {
          this.categories = response.data
          this.deleteEmptyCategories()
        })
      },
      deleteEmptyCategories() {
        this.categories = this.categories.filter((el) => el.count != 0)
      },
      getSolutions(more = false) {
        this.isLoading = true
        axios.request({
          method: 'GET',
          url: `${baseUrl}/solution`,
          data: this.form,
          headers: { 'content-type': 'application/json' },
          params: this.filters
        }).then(response => {
          this.solutions = (more)? this.solutions.concat(response.data) : response.data
          this.totalPages = response.headers['x-wp-total']
          this.isLoading = false
        }).catch((error) => {
          this.errors = Object.assign(this.errors, error.response.data)
        })
      },
      getCategory(category_id) {
        let category = this.categories.filter((obj) => obj.id === category_id)
        let categoryName = (category.length > 0)? category[0]['name'] : ''
        return categoryName
      },


    }
  })
}
